
const commonApi = {
  riskVerification: '/sale/api/verification-code/risk-status',
  loginSendCode: '/sale/api/verification-code/sms',
  getGraphicVerificationCode: '/sale/api/verification-code/graph-rest',
  getInstanceConfig: '/sale/api/web-instance-config/get/web-config',
  getInstanceConfigOld: '/sale/api/web-instance-config/get/by-app-id',
  generateCaptcha: '/api/captcha/generate-rest',
  login: '/sale/api/login/register-login',
  register: '/sale/api/member/auth/register',
  checkDistance: '/api/delivery/check/distance',
  getOrderSetting: '/api/shop',
  getDefaultAddress: '/api/member/address/default',
  checkDelivery: '/api/delivery/check',
  getShopDistance: '/api/delivery/getShopDistance',
  postGraphVerify: '/sale/api/verification-code/graph-verify',
  postVoiceCode: '/sale/api/verification-code/voice',
  getAddressDetails: '/sale/api/google-map/places/query-current-detail',
  getAutoComplete: '/sale/api/google-map/places/auto-complete',
  getGooglePlaces: '/sale/api/google-map/places/detail',
  getAddressList: '/sale/api/address/list',
  getDeliveryAddressList: '/sale/api/address/delivery/list',
  saveAddress: '/sale/api/address/save',
  deleteAddress: '/sale/api/address/delete',
  getGoogleMapNearby: '/sale/api/google-map/places/query-nearby',
  addressSaveCheck: '/sale/api/address/save/check',
  orderSetting:  '/sale/api/store/order-setting',
  getGatewayConfigByDomainName: '/sale/api/payment/getGatewayConfigByDomainName',
  campaignClick: '/sale/api/common/campaign/click'
}

export default commonApi;
